import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import "firebase/compat/messaging";
import "firebase/compat/storage";
const basePath = require("./basePath.ts");

const generalConfig = {
  apiKey: "AIzaSyDIhCZPXOBS6JEyKm7RowXjiYyke3pCrCE",
  authDomain: "project-portal-dev.firebaseapp.com",
  databaseURL: "https://project-portal-dev.firebaseio.com",
  projectId: "project-portal-dev",
  storageBucket: "project-portal-dev.appspot.com",
  messagingSenderId: "719246142067",
  appId: "1:719246142067:web:b2bc423ef1cc9028bfd806",
};

const releaseConfig = {
  apiKey: "AIzaSyA8crnPm2cQTcYh10ICIqtO6obHIHNOwX8",
  authDomain: "projects-sight-prod.firebaseapp.com",
  databaseURL: "projects-sight-prod.firebaseio.com",
  projectId: "projects-sight-prod",
  storageBucket: "projects-sight-prod.appspot.com",
  messagingSenderId: "686467731083",
  appId: "1:686467731083:web:e0930668b4c6b3024a4e8e",
};

firebase.initializeApp(process.env.NODE_ENV === "production" ? releaseConfig : generalConfig);

if (process.env.NODE_ENV === "production") {
  firebase.firestore.setLogLevel("error");
} else {
  firebase.firestore.setLogLevel("error");
}

export const firebaseApp = firebase;
export const firestore = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();

export const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null;
export const baseApiUrl = basePath.baseApiUrl;
export const baseAzureApiUrl = basePath.baseAzureApiUrl;
export const recaptchaSiteKey = process.env.NODE_ENV === "production" ? "6Lf-BFspAAAAADwZH1ggFnQnRwjc1wPDxX4T_eXa" : "6LcpW6omAAAAAFqy1UQBXEQQx6tFpptaqYj2jcpp";
export const firebaseVapidKey =
  process.env.NODE_ENV === "production"
    ? "BL0gjgvpJbeBMJcrLlw9EegMyaKbhIKEe0BojaMefd98KPYzCDwnnRie3l_d3CVG37hqNBnAYtUHYGD-5Qxp3uc"
    : "BF-wzbNdAXK8VsDEqx81kql9GaDeWTuLPi-Je0onltaqy8I-pOqdRVI7jPxcSNEIpnzbpBRoc4Ezxtuv_S9DZxs";
